import React from "react";
import { Avatar } from "@mui/material";
import { IconLocation, IconTag } from "../../Icons";
import { PersonAvatar } from "../../modules/People/PersonAvatar";
import { IconSuggestionBox } from "../Content/IconSuggestion";
export const Suggestion = ({ option, ...rest }) => {
    let icon = (<Avatar sx={{ bgcolor: '#93ddb9' }}><IconTag /></Avatar>)
    if (option.type === 'location') icon = (<Avatar sx={{ bgcolor: '#a0cdee' }}><IconLocation /></Avatar>)
    else if (option.type === 'person') {
        // icon = (<IconPerson />)
        icon = (<PersonAvatar person={option} />)
    }
    return (<IconSuggestionBox icon={icon} label={option.name} {...rest} />)
}